import { useState } from 'react';
import styled from 'styled-components';
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const SignUp = () => {
  const [userInfo, setUserInfo] = useState({
    userId: '',
    userPassword: '',
    confirmPassword: '',
    userName: '',
    userEmail: ''
  });

  const [isIdChecked, setIsIdChecked] = useState(false);

  const onChange = (e) => {
    const {
      name,
      value
    } = e.target;
    setUserInfo({
      ...userInfo,
      [name]: value
    });
    if (name === 'userId') {
      setIsIdChecked(false);
    }
  };

  // 아이디 중복 체크 알림 수정
  const checkIdDup = () => {
    if (Common.isEmpty(userInfo.userId)) {
      alert('Please enter your ID.');
      return;
    }

    Server.sendGet('user/customer/checkId', { userId: userInfo.userId }, (res) => {
      if (res['resultCount'] === 0) {
        alert('This ID is available.');
        setIsIdChecked(true);
      } else {
        alert('This ID is already in use.');
        setIsIdChecked(false);
      }
    }).then();
  };

  // 유효성 검사 및 가입 완료 알림 수정
  const userJoin = () => {
    const {
      userId,
      userPassword,
      confirmPassword,
      userName,
      userEmail
    } = userInfo;

    if (Common.isEmpty(userId)) {
      return alert('Please enter your ID.');
    }
    if (!isIdChecked) {
      return alert('Please check ID availability.');
    }
    if (Common.isEmpty(userPassword)) {
      return alert('Please enter your password.');
    }
    if (userPassword !== confirmPassword) {
      return alert('Passwords do not match.');
    }
    if (Common.isEmpty(userName)) {
      return alert('Please enter your name.');
    }
    if (Common.isEmpty(userEmail)) {
      return alert('Please enter your email.');
    }

    Server.sendPost('user/join', {
      userId,
      userPassword,
      userName,
      userEmail
    }, (res) => {
      if (res['apiCode'] === 'S001') {
        alert('Registration completed successfully.');
        document.location.href = '/login';
      }
    });
  };

  return (
    <VisualWrap>
      <Inner>
        <JoinBox>
          <LogoBox>
            <img
              src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/ust_logo.webp'
              alt='ust logo'
            />
          </LogoBox>
          <JoinForm>
            <InputGroup>
              <LoginInput
                style={{ width: '235px' }}
                type='text'
                name='userId'
                placeholder='ID'
                value={userInfo.userId}
                onChange={onChange}
              />
              <CheckBtn onClick={checkIdDup}>Check</CheckBtn>
            </InputGroup>

            <LoginInput
              type='password'
              name='userPassword'
              placeholder='Password'
              value={userInfo.userPassword}
              onChange={onChange}
            />

            <LoginInput
              type='password'
              name='confirmPassword'
              placeholder='Confirm Password'
              value={userInfo.confirmPassword}
              onChange={onChange}
            />
            {/* 하단 경고 문구 영어로 변경 */}
            {userInfo.confirmPassword && userInfo.userPassword !== userInfo.confirmPassword && (
              <ErrorMsg>Passwords do not match.</ErrorMsg>
            )}

            <LoginInput
              type='text'
              name='userName'
              placeholder='Name'
              value={userInfo.userName}
              onChange={onChange}
            />

            <LoginInput
              type='email'
              name='userEmail'
              placeholder='Email'
              value={userInfo.userEmail}
              onChange={onChange}
            />
          </JoinForm>
          <ActionBox>
            <JoinBtn onClick={userJoin}>Sign Up</JoinBtn>
            <CancelBtn onClick={() => window.history.back()}>Back</CancelBtn>
          </ActionBox>
        </JoinBox>
      </Inner>
    </VisualWrap>
  );
};

/* 스타일 컴포넌트는 이전과 동일 */
const VisualWrap = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/login_bg.webp') no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
  }
`;
const Inner = styled.div` z-index: 3;
  position: relative;
  width: 100%;
  max-width: 400px; `;
const JoinBox = styled.div` text-align: center;
  padding: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  backdrop-filter: blur(5px); `;
const LogoBox = styled.div` margin-bottom: 30px; `;
const JoinForm = styled.div` display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 30px; `;
const InputGroup = styled.div` display: flex;
  gap: 10px;
  justify-content: center; `;
const LoginInput = styled.input`
  width: 320px;
  height: 45px;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  border: none;
  outline: none;
  font-size: 16px;
  color: #000;

  &::placeholder {
    color: #777;
  }
`;
const CheckBtn = styled.button`
  width: 75px;
  height: 45px;
  background: #333;
  color: #fff;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #000;
  }
`;
const ErrorMsg = styled.p` color: #ff4d4d;
  font-size: 12px;
  text-align: left;
  margin: -10px 0 0 40px; `;
const ActionBox = styled.div` display: flex;
  gap: 10px;
  justify-content: center; `;
const JoinBtn = styled.button`
  width: 120px;
  height: 45px;
  background: #0072B9;
  color: #fff;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  font-size: 18px;
`;
const CancelBtn = styled.button`
  width: 120px;
  height: 45px;
  background: #666;
  color: #fff;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  font-size: 18px;
`;

export default SignUp;
